import React from "react";
import { Label } from "@/components/ui/label";
import { InfoHint, RequiredMark, OptionalLabel, SectionDescription } from "@/components/InfoHint";

export function SectionPanel({ number, title, required, optional, icon, help, description, testid, actions, children }) {
  return (
    <div className="rounded-2xl border border-black/10 bg-white p-5" data-testid={testid}>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            {icon && (
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-lg bg-[rgba(97,203,163,0.18)] text-[#61CBA3]">
                {icon}
              </span>
            )}
            <div className="font-display text-lg font-semibold text-black">
              {number ? `${number}. ` : ""}{title}
              {required && <RequiredMark />}
              {optional && <OptionalLabel />}
            </div>
            {help && <InfoHint testid={`${testid}-info`}>{help}</InfoHint>}
          </div>
          {description && <SectionDescription>{description}</SectionDescription>}
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}

export function Field({
  label,
  children,
  testid,
  required,
  optional,
  hint,
  className = "",
  labelClassName = "",
  controlClassName = "",
}) {
  return (
    <div className={className} data-testid={testid}>
      <div className={`flex items-center gap-1.5 flex-wrap ${labelClassName}`}>
        <Label className="text-xs uppercase tracking-wider text-black/60">{label}</Label>
        {required && <RequiredMark />}
        {optional && <OptionalLabel />}
        {hint && <InfoHint testid={`${testid}-info`}>{hint}</InfoHint>}
      </div>
      <div className={`mt-1 ${controlClassName}`}>{children}</div>
    </div>
  );
}
